Vue.component('googlemap', {
    template: '#maps',
    delimiters: ['[[', ']]'],
    props: ['name', 'latmarker', 'longmarker'],
    data: function () {
        return {
            mapName: this.name + "-map",
            markerCoordinates: {
                latitude: this.latmarker,
                longitude: this.longmarker
            }
        }
    },
    mounted: function () {
        var bounds = new google.maps.LatLngBounds();
        var element = document.getElementById(this.mapName);
        var mapCentre = this.markerCoordinates;
        var options = {
            zoom: 14,
            center: new google.maps.LatLng(mapCentre.latitude, mapCentre.longitude),
            mapTypeControl: false
        };
        var map = new google.maps.Map(element, options);
        var position = new google.maps.LatLng(this.markerCoordinates.latitude, this.markerCoordinates.longitude);
        var marker = new google.maps.Marker({  position: position, map: map });
    }
});
